///<reference path="../Core/PublicFunctions.js"/>
///<reference path="../Core/ModuleTabs.js"/>
var _tabNo = 0;
//var _imgPath; // ADS 29-Dec-2004 - path is duplicated above
function AddTask(
  name,
  url,
  monk,
  apid,
  vid,
  fromMenu,
  targetViewId,
  appletParams,
  title,
  asChild
) {
  // mark tab pane as busy
  _TabProc = false;
  // Make the tab
  if (!isMenuReady() || !isViewReady()) {
    log("Add Task - Menu or View is not ready yet", "warning");
    setTimeout(function waitForView() {
      AddTask(
        name,
        url,
        monk,
        apid,
        vid,
        fromMenu,
        targetViewId,
        appletParams,
        title,
        asChild
      );
    }, 100);
    return;
  }
  var viewdoc = GetIFrameViewDocument();
  var table = document.getElementById("tblTabs");
  var cell = null;
  var tabid = vid;
  instance.notifyUser(resx.GetString("Frame", "opening") + title);
  window.frames["menuAndView"].addSessionItem(vid, title, targetViewId);
  
  if (table) {
    var row = table.rows[0];
    if (row.cells.length > 0) {
      DeselectCurrentTab(targetViewId);
      var startcap = row.cells[row.cells.length - 1];
    } else {
      var startcap = row.insertCell(-1);
    }
    // ADS 10-May-2004 - W2003 Server does weird things when you intermix insertCell with createElement...
    cell = row.insertCell(-1);
    cell.id = tabid;
    cell.tabName = " ";
    cell.monikerAndTitle = monk;
    cell.setAttribute("appletid", apid);
    cell.appletParams = appletParams;
    var endcap = row.insertCell(-1);
    if (table.currentCell) {
      cell.parentId = table.currentCell.id;
      //if this is a child view, register the dependency
      if (asChild) {
        if (!table.currentCell.childViews) table.currentCell.childViews = [];
        table.currentCell.childViews.push(cell);
      }
    }
    table.currentCell = cell;
  }
  moniker = monk;
  appletid = apid;
  var src = _AppPath + "VFrame.htm?";
  var split = url.indexOf("?");
  if (split > -1) {
    url = url.substr(0, split) + "&" + url.substr(split + 1);
  }
  src +=
    "navifwd=" + url + "&monk=" + monk + "&apid=" + apid + "&tabid=" + tabid;
  if (fromMenu) {
    src += "&fromMenu=true";
  }
  if (appletParams) {
    src += "&appletParams=" + urlEscape(appletParams);
  }
  // Since this is going to end up in the url, make sure we encode apostrophes
  src = src.replace("'", "'");
  // ADS 21-Sept-2004 - Attempt to prevent frames from stacking on top of each other
  var ifrm = viewdoc.createElement("IFRAME");
  ifrm.id = "_Task_Tab_Content" + _tabNo;
  if (!ifrm.getAttribute("data-auto-uid"))
  {
	ifrm.setAttribute("data-auto-uid", moniker + _tabNo + "_TaskTabContent");
  }
  ifrm.setAttribute("data-auto-applet-id", apid);
  var maxRequestRetries = window.runTimeOptions.maxRequestRetries != null ? window.runTimeOptions.maxRequestRetries : 0;
  var retriesEnabled = maxRequestRetries != 0;

  if (!retriesEnabled) {
    ifrm.src = src; //setting the source sends a request to the src url for content
  }

  ifrm.title = title;
  ifrm.frameBorder = 0;
  ifrm.style.cssText = "width:100%;height:100%;";
  ifrm.setAttribute("seamless", "1");

  if (cell != null) {
    cell.frametag = ifrm;
  }
  if (viewdoc.forms[0]) {
    viewdoc.forms[0].appendChild(ifrm);
  } else if (viewdoc.body) {
    viewdoc.body.appendChild(ifrm);
  } else {
    viewdoc.appendChild(ifrm);
  }

  if (retriesEnabled) {
      // Call after appendChild to stop the first onload Call
      if (instance && instance.log) instance.log("Loading iframe content.", "Info");
      ifrm.onload = onIframeLoadWithRetry(ifrm, src, maxRequestRetries);
      // Call onload by triggering src
      ifrm.src = src;
  } 

  ifrm.contentWindow.applyPublicFunctions = applyPublicFunctions;
  ifrm.contentWindow.moniker = moniker;
  _tabNo++;
  hideModalDivs();
}

//replace iframe.onload with a method that sets the src and retries on failure
function onIframeLoadWithRetry(iframe, src, maxRequestRetries) {
  if (!iframe) throw "iframe is required";
  if (!src) throw "src is required";
  if (!maxRequestRetries) throw "maxRequestRetries is required";

  //closure variables
  var retryAttempts = 0;
  var retryTimeout = 1000;

  //retry function
  var retrySetIframeSrc = function () {
    if (maxRequestRetries <= -1 || retryAttempts < maxRequestRetries) {
      retryAttempts++;
      if (instance && instance.log) instance.log("Waiting " + retryTimeout + "ms and retrying loading iframe content.", "info");
      window.showWaitMsg(); //prevent clicking while this error is occuring otherwise the entire application can get in an invalid state and the page will require a reload
      //wait before retrying
      setTimeout(function () {
        cblock.clearCookies();
        if (instance && instance.log) instance.log("Retrying loading iframe content. Retry attempt " + retryAttempts + ".", "info");
        iframe.src = src;
      }, retryTimeout);
    }
    else { //max retries reached
      if (instance && instance.log) instance.log("Loading iframe content failed. Max retry attempts reached.", "error");
      $(iframe).css("opacity", 1); //show iframe
      //view might not be in the viewCache here, so view.showMessageBox() is not available
      alert("The request to the server failed. Try refreshing the page. If the issue persists, contact the Administator.");
      window.hideWaitMsg();
    }
  };

  //return override for iFrame.onload - set src and retry on failure
  //iFrame.onload fires twice: once when the iFrame is appended to the body, and again when the iFrame.src is set
  return function () {
    $(iframe).css("opacity", 0); //hide iframe using opacity. Using $(iframe).hide() messes up our rendering
    var frameContent = iframe.contentDocument;
    //if the viewframe was created, setting the frame.src was successful
    if (frameContent && frameContent.body && frameContent.body.attributes && frameContent.body.attributes['viewframe']) {
        if (instance && instance.log) instance.log("Loaded iframe content successfully.", "info");
        $(iframe).css("opacity", 1); //show iframe
    }
    else { //frame was not loaded successfully. retry.
        if (instance && instance.log) instance.log("Loading iframe content failed. Body with 'viewframe' attribute missing.", "info")
        retrySetIframeSrc();
    }    
  };
}

// removes a specific task.  This does not have to be the current task.  It does not change the current visible task.
function RemoveSpecificTask(targetViewId) {
  var table = document.getElementById("tblTabs");
  if (table) {
    // if we are trying to remove the current task then use the RemoveCurrentTask as that handles
    // this particular situation.
    if (table.currentCell.id == targetViewId) {
      RemoveCurrentTask(targetViewId);
      return;
    }
    //10/23/07 cpb close the children first if any because there might be some children windows opened.  Closing the parent without this
    //will cause "Component list missing from applet state" error.
    closeInternal(targetViewId);
    //end 10/23/07
    if (table.rows[0].cells.length == 0) {
      window.frames["cblock"].send("", targetViewId);
    }
    var current = document.getElementById(targetViewId);
    var currentChildren = current.childViews;
    // Remove contents
    if (current && current.frametag) {
      //RG 10-27-04 To fix memory leak issues in IE we must clear the IFrame reference as
      //well as set the src to null
      //If Cblock retries is enabled, we are getting rid of the content in the iframe
      // we will need to reset the onload function to prevent it from entering the retry method
      if (window.runTimeOptions.maxRequestRetries != 0) current.frametag.onload = function () { };
      current.frametag.src = null;
      $(current.frametag).remove();
      instance.notifyUser(
        resx.GetString("Frame", "closing") + current.textContent
      );
    }
    // splice the task by linking up the previous and next siblings
    if (current.previousSibling) {
      current.previousSibling.nextSibling = current.nextSibling;
    }
    if (current.nextSibling) {
      current.nextSibling.previousSibling = current.previousSibling;
    }
    // Remove tab control
    if (current.previousSibling) {
      $(current).remove();
      if (
        instance.frames &&
        instance.frames["menuAndView"] &&
        instance.frames["menuAndView"].addSessionItem
      ) {
        instance.frames["menuAndView"].removeSessionItem(
          current.id,
          targetViewId
        );
      }
    }
    // clean up so we don't have a memory leak
    delete current.nextSibling;
    delete current.previousSibling;
    delete current.frametag;
    delete current.childViews;
    //If we have any child views, close them as well. This mimics the functionality when new windows are opened
    if (currentChildren && currentChildren.length > 0) {
      $.each(currentChildren, function(index, value) {
        //Make sure the View Cell Still exists
        var childCell = document.getElementById(value.id);
        if (childCell.length > 0 && childCell[0] == value) {
          var childDoc = GetViewDocument(value.id);
          if (childDoc && childDoc.forms.length > 0) {
            var kai =
              "<KAI apid='" +
              childDoc.forms[0].getAttribute("apid") +
              "' monk='" +
              childDoc.forms[0].getAttribute("monk") +
              "'/>";
            sendCustomRequest(kai, undefined);
          }
          RemoveSpecificTask(value.id);
        }
      });
    }
  } else {
    window.frames["cblock"].send("", targetViewId);
  }
}
function RemoveCurrentTask(targetViewId) {
  var table = document.getElementById("tblTabs");
  if (table) {
    //10/23/07 cpb close the children first if any because there might be some children windows opened.  Closing the parent without this
    //will cause "Component list missing from applet state" error.
    closeInternal(targetViewId);
    //end 10/23/07
    if (table.rows[0].cells.length == 0)
      window.frames["cblock"].send("", targetViewId);
    else if (table.currentCell != null) {
      var next = "";
      var current = table.currentCell;
      var currentChildren = current.childViews;
      // Remove contents
      if (current && current.frametag) {
        //RG 10-27-04 To fix memory leak issues in IE we must clear the IFrame reference as
        //well as set the src to null
        //If Cblock retries is enabled, we are getting rid of the content in the iframe
        // we will need to reset the onload function to prevent it from entering the retry method
        if (window.runTimeOptions.maxRequestRetries != 0) current.frametag.onload = function () { };
        current.frametag.src = null;
        $(current.frametag).remove();
        instance.notifyUser(
          resx.GetString("Frame", "closing") + $(current).text()
        );
      }
      var parent = null;
      if (current.parentId) {
        parent = document.getElementById(current.parentId);
      }
      // Go to the Launching Tab, or Previous, Or MyInfor if not found
      if (parent) {
        next = current.parentId;
      } else if (current.previousSibling) {
        // PHIL S: Never switch to the more tab.  This causes problems when the more tab is removed as
        // result of removing this task.
        if (
          current.nextSibling &&
          current.nextSibling.nextSibling &&
          current.nextSibling.nextSibling.id != "MoreViewTab" &&
          current.nextSibling.nextSibling.id != undefined
        ) {
          next = current.nextSibling.nextSibling.id;
        } else if (current.previousSibling.previousSibling) {
          next = current.previousSibling.previousSibling.id;
        }
      } else {
        next = table.rows[0].cells[1].id;
      }
      // Remove tab control
      if (current.previousSibling) {
        if (table.rows[0].cells.length == 3) {
          $(current.previousSibling).remove();
        }
        if (current.nextSibling) {
          $(current.nextSibling).remove();
        }
        current.parentNode.removeChild(current);
        if (
          instance.frames &&
          instance.frames["menuAndView"] &&
          instance.frames["menuAndView"].addSessionItem
        ) {
          instance.frames["menuAndView"].removeSessionItem(
            current.id,
            targetViewId
          );
        }
        var viewdoc;
        if (instance.frames && instance.frames["view"]) {
          viewdoc = instance.frames["view"].document;
        }
      }
      // Clear current tab
      DeselectCurrentTab();
      current.nextSibling = null;
      current.previousSibling = null;
      current.frametag = null;
      current.childViews = null;
      table.currentCell = null;
      // If any tabs left, select the leftmost one
      if (next != "") {
        var tpo = _TabProc;
        _TabProc = true;
        SelectTab(next, targetViewId);
        // ADS 1-Nov-2004 - Update the rest of the tabs
        var tab = table.currentCell.nextSibling;
        while (tab && tab.nextSibling && tab.nextSibling.nextSibling) {
          tab = tab.nextSibling;
          tab = tab.nextSibling;
        }
        _TabProc = tpo;
        //RG 12-27-08 Set focus to the current view.  Allows hot keys to function GetView( targetViewId).focus( targetViewId);
      }
      //If we have any child views, close them as well. This mimics the functionality when new windows are opened
      if (currentChildren && currentChildren.length > 0) {
        $.each(currentChildren, function(index, value) {
          //Make sure the View Cell Still exists
          var childCell = document.getElementById(value.id);
          if (childCell == value) {
            _TabProc = true;
            SelectTab(value.id, targetViewId);
            var childDoc = GetViewDocument(value.id);
            RemoveCurrentTask(value.id);
            if (childDoc && childDoc.forms.length > 0) {
              var kai =
                "<KAI apid='" +
                childDoc.forms[0].getAttribute("apid") +
                "' monk='" +
                childDoc.forms[0].getAttribute("monk") +
                "'/>";
              // fix issue with xml error 'multiple root elements' when trying to close a tab with multiple child tabs open.
              // if _Ready is false then sendCustomRequest will append multiple requests together at the same xml node level
              // sendCustomRequest will reset _Ready back to false
              _Ready = true;
              sendCustomRequest(kai, undefined);
            }
          }
        });
      }
    }
  } else {
    window.frames["cblock"].send("", targetViewId);
  }
}
function ClearAllTabs(targetViewId) {
  var table = document.getElementById("tblTabs");
  if (table) {
    while (table.rows[0].cells.length > 0) {
      table.rows[0].removeChild(table.rows[0].cells[0]);
    }
    table.currentCell = null;
    if (
      window.frames &&
      window.frames["menuAndView"] &&
      window.frames["menuAndView"].addSessionItem
    ) {
      window.frames["menuAndView"].updateModuleHeader(
        "",
        undefined,
        targetViewId
      );
    }
  }
}
///
///Remove all tasks except the first one.  Used in admin site functionality
///
function ClearAllTasksExceptFirst(targetViewId) {
  //log( "Remove all tasks except first" , targetViewId);
  DeselectCurrentTab(targetViewId);
  var table = document.getElementById("tblTabs");
  if (table) {
    //find the first frame tag cell..
    var firstFrameCell = null;
    var frameIndex = null;
    for (var i = 0; i < table.rows[0].cells.length; i++) {
      if (table.rows[0].cells[i].frametag != undefined) {
        firstFrameCell = table.rows[0].cells[i];
        frameIndex = i;
        break;
      }
    }
    if (firstFrameCell) {
      //loop through finding each iframe task and removing them
      var otherFrames = [];
      for (var i = frameIndex + 1; i < table.rows[0].cells.length; i++) {
        if (table.rows[0].cells[i].frametag != undefined)
          otherFrames.push(table.rows[0].cells[i]);
      }
      //now loop through and remove each frame
      var f = otherFrames.pop();
      while (f) {
        table.currentCell = f;
        SelectTab(f.id, targetViewId);
        RemoveCurrentTask(targetViewId);
        f = otherFrames.pop();
      }
      //all other tasks are gone.  Just set the first one to selected item
      table.currentCell = firstFrameCell;
      SelectTab(firstFrameCell.id, targetViewId);
    }
  }
}
function SetCurrentTabName(title, targetViewId) {
  //log( "SetCurrentTabName( " + title + " , targetViewId)" );
  var frames = instance.frames;
  if (frames) {
    var table = document.getElementById("tblTabs");
    if (table) {
      if (table.currentCell && table.currentCell != null)
        table.currentCell.textContent = title;
      if (frames["menuAndView"] && frames["menuAndView"].updateSessionItem) {
		  if (!frames["menuAndView"].frameElement.getAttribute("data-auto-uid"))
		  {
			frames["menuAndView"].frameElement.setAttribute("data-auto-uid", title);
		  }
        frames["menuAndView"].updateSessionItem(
          targetViewId,
          targetViewId,
          title
        );
        frames["menuAndView"].updateModuleHeader(
          title,
          undefined,
          targetViewId
        );
      }
    }
  }
}
function SetTabName(id, title, targetViewId) {
  //log( "SetTabName( " + id + ", " + title + " , targetViewId)" );
  var frames = instance.frames;
  if (frames) {
    var tab = document.getElementById(id);
    if (tab) {
      tab.textContent = title;
      if (
        frames &&
        frames["menuAndView"] &&
        frames["menuAndView"].updateSessionItem
      ) {

		  if (!frames["menuAndView"].frameElement.getAttribute("data-auto-uid"))
		  {
			frames["menuAndView"].frameElement.setAttribute("data-auto-uid", title);
		  }
        frames["menuAndView"].updateSessionItem(id, targetViewId, title);
        frames["menuAndView"].updateModuleHeader(
          title,
          undefined,
          targetViewId
        );
      }
    }
  }
}
function SetTabNameEx(tab, targetViewId) {
  if (tab) {
    tab.textContent = tab.tabName;
    if (
      window.frames &&
      window.frames["menuAndView"] &&
      window.frames["menuAndView"].addSessionItem
    ) {
		var existingAttribute = window.frames["menuAndView"].frameElement.getAttribute("data-auto-uid");
		if (!existingAttribute)
		{
			window.frames["menuAndView"].frameElement.setAttribute("data-auto-uid", tab.tabName + "_tabName");
		}
      window.frames["menuAndView"].updateModuleHeader(
        tab.tabName,
        undefined,
        targetViewId
      );
    }
  }
}
function SetCurrentTabTitle(title, vid, targetViewId) {
  var frames = instance.frames;
  if (frames) {
    var tab = document.getElementById(vid);
    if (tab && (!tab.tabName || tab.tabName.length <= 1)) {
      tab.tabName = title;
      var $tab = $(tab);
      var text = $tab.text();
      var html = $tab.html();
      if (text == html || text == " ") $tab.text(title);
      if (frames["menuAndView"] && frames["menuAndView"].addSessionItem) {
		  
		  if (!frames["menuAndView"].frameElement.getAttribute("data-auto-uid"))
		  {
			frames["menuAndView"].frameElement.setAttribute("data-auto-uid", title);
		  }
        frames["menuAndView"].updateSessionItem(vid, targetViewId, title);
        frames["menuAndView"].updateModuleHeader(
          title,
          undefined,
          targetViewId
        );
      }
    }
  }
  // END ADS 20-Sept-2004
}
function DeselectCurrentTab(targetViewId) {
  var table = document.getElementById("tblTabs");
  if (table && table.currentCell) {
    var cell = table.currentCell;
    cell.frametag.style.display = "none";
  }
}
function SelectTab(id, targetViewId, select) {
  var table = document.getElementById("tblTabs");
  if (table && _TabProc) {
    var cells = table.rows[0].cells;
    var newcell = null;
    for (var i = 0; i < cells.length; i++) {
      if (cells[i].id == id) {
        newcell = cells[i];
        break;
      }
    }
    if (newcell && newcell != table.currentCell) {
      //deselect the current tab
      DeselectCurrentTab(targetViewId);
      table.currentCell = newcell;
      if (newcell && newcell != null) {
        var iframe = newcell.frametag;
        iframe.style.display = "block";
		// HPS-113070: Loads the missing tabs
		var viewTab = iframe.contentWindow.frames["viewTab"];
        viewTab.updateControlSize(false, viewTab._currentViewId);
      }
    }
    var menuView = instance.frames["menuAndView"];
    if (select == undefined) menuView.selectSessionItem(id, targetViewId);
    menuView.updateSessionIcon(id, targetViewId);
    var title = $(newcell).text();
    menuView.updateModuleHeader(title, undefined, id);
    instance.notifyUser(resx.GetString("Frame", "selecting") + title);
    SystemEvents("viewChanged", id).trigger();
    //Set focus to the document so the user can tab and continue using the system
    if (
      newcell &&
      newcell.frametag.contentWindow.frames["viewTab"].findFirstControl
    ) {
      var cont =
        newcell.frametag.contentWindow.frames["viewTab"].findFirstControl() ||
        newcell.ownerDocument.body;
      try {
        cont.focus();
      } catch (ex) {}
    }

    if (IsMingle()) {
        //whenever we click another tab, we are essantially changing the view screen so we will
        //create a business object and publish a context Message to Mingle that will be consumed by Smart help.
    if (instance.contextMessaging) {
        var Re = new RegExp("\\.", "g");
        var moniker = newcell.monikerAndTitle.split(';')[0];
        var contextID = new Date().getTime();
        var entityType = moniker.toLowerCase().replace(Re, "_").replace("hansen", "infor");
        var supportProductId = contextMessaging.GetSupportId(moniker);
        var logicalId = decodeURIComponent(instance.contextMessaging.getUrlVars()["LogicalId"]);

        if (logicalId == "undefined") {
          logicalId = "lid://infor.ips.ips";
        }
        var entities =
          [
            {
              entityType: entityType,
              id1: "",
              name: moniker, 
              description: moniker,
              accountingEntity: "",
              location: "",
              drillbackURL: "?LogicalId=" + logicalId + "&monk=" + moniker,
              bodReference: ""
            }
          ];
            
          var businessContext =
          {
            entityType: entityType,
            screenId: "PublicSector_" + moniker,
            logicalId: logicalId,
            entities: entities,
            supportProductId: supportProductId,
            contextId: contextID,
            originatingTime: contextID
          };
          contextMessaging.PublishContextMessage("inforBusinessContext", businessContext);
        }

     }

    // Publish a shortcut message to enable the "favorite" icon for this applet
    if (instance.contextMessaging) {
      contextMessaging.PublishContextMessage("setShortcutContext", {
        name: newcell.textContent,
        description: newcell.textContent,
        absoluteURL: "false",
        shortcutContext:
          newcell.monikerAndTitle +
          ";" +
          newcell.textContent +
          ";" +
          newcell.appletParams
      });
    }
    showModalDivs(id);
  }
}
